/**
 * @file     vowSignupLeadType.ts
 * @purpose  Pick the conversion lead type the VOW wall files on account
 *           creation and on a mid-flow close. /property-finder (A and B) uses this wall as the
 *           listing-click gate, so it must fire generate_lead_buyer the
 *           same way the listings-access verify route does. Other VOW
 *           surfaces remain a soft user-signup.
 */

import type { LeadType } from '@/services/leads/leadTypes';

const BUYER_CONVERSION_PREFIXES = ['/property-finder'] as const;

export function vowSignupLeadType(pathname: string): LeadType {
  const path = safePath(pathname);
  if (BUYER_CONVERSION_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return 'buyer';
  }
  return 'user-signup';
}

/**
 * The lead type for a visitor who closes the wall mid-flow. On a buyer
 * conversion surface it is a buyer partial, so the close reports
 * generate_lead_buyer like the completed signup does; elsewhere it stays a
 * signup partial.
 */
export function vowPartialLeadType(pathname: string): LeadType {
  return vowSignupLeadType(pathname) === 'buyer' ? 'vow-partial-buyer' : 'vow-partial';
}

export function vowSignupFlowId(type: LeadType): string {
  return type === 'buyer' ? 'vowWall' : 'userSignup';
}

function safePath(pathname: string): string {
  const raw = pathname.split('?')[0]?.split('#')[0] ?? '/';
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes(':')) return '/';
  return raw.replace(/\/+$/, '') || '/';
}
